import React, { forwardRef } from 'react'
import { Input } from 'antd'

import classNames from 'classnames'

import styles from './styles.module.scss'

import type { ForwardRefRenderFunction, WheelEventHandler } from 'react'
import type { InputRef } from 'antd'
import type { LntInputProps } from './types'

const Component: ForwardRefRenderFunction<InputRef, LntInputProps> = (props, ref) => {
  const { className: outerClassName, value, ...restProps } = props

  const className: string = classNames({ [styles.nonEmptyInput]: !!value }, styles.lntInputNumber, outerClassName)

  const onWheel: WheelEventHandler<HTMLInputElement> = e => {
    const target = e.target as HTMLElement | null
    if (target) {
      target.blur()
    }
  }

  return (
    <Input
      onWheel={ onWheel }
      { ...restProps }
      ref={ ref }
      className={ className }
      value={ value }
    />
  )
}

export const LntInput = forwardRef<InputRef, LntInputProps>(Component)
